import {
    Component,
    Input,
    Output,
    EventEmitter,
    HostBinding
} from '@angular/core';

@Component({
    selector: 'app-rarity',
    template: '',
    styleUrls: ['./rarity.component.less']
})
export class RarityComponent {
    @Input() value: number;
    @HostBinding('class') get rarity() {
        return `--rarity-${ this.value }`;
    }

    constructor(
    ) {
    }
}
